import { useCallback, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
import { atcb_action } from 'add-to-calendar-button';
import { makeStyles } from '@material-ui/core';
import ActionButton from '../actionButton';
import '../../../styles/add_calendar.css';
import { prepareOneOnOneCalendarData } from '../../../utility/oneOnOne';
import { ACTION_BUTTON_TYPES } from '../actionButton/config';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    width: 'fit-content',
  },
  triggerButtonSmall: {
    width: 24,
    height: 24,
  },
  triggerIconSmall: {
    width: 24,
    height: 24,
  },
}));

const calendarOptions = ['Google', 'Microsoft365', 'iCal', 'Outlook.com'];

const OneOnOneCalendar = ({
  className = undefined,
  translations,
  record,
  isSmall = false,
}) => {
  const classes = useStyles();
  const triggerRef = useRef(null);

  const details = useMemo(
    () => prepareOneOnOneCalendarData(translations, record),
    [translations, record]
  );

  const handleCalendarButtonClick = useCallback(
    e => {
      const config = {
        timeZone: 'currentBrowser',
        lightMode: 'bodyScheme',
        options: calendarOptions,
        listStyle: 'overlay',
        buttonStyle: 'round',
        trigger: 'click',
        hideTextLabelButton: true,
        hideBranding: true,
        hideBackground: true,
        size: 0,
        ...details,
      };
      e.stopPropagation();
      atcb_action(config, triggerRef?.current);

      setTimeout(() => {
        const dropdownWrapper = document.getElementById(
          'atcb-customTrigger-my-custom-trigger-host'
        );
        const dropdown =
          dropdownWrapper?.shadowRoot.querySelector('.atcb-dropdown');
        const overlay =
          dropdownWrapper?.shadowRoot.getElementById('atcb-bgoverlay');

        if (dropdownWrapper && dropdown && triggerRef?.current) {
          const dropdownHeight = 176;
          const triggerOffset = isSmall ? 24 : 30;
          const dropdownWrapperRect = dropdownWrapper.getBoundingClientRect();
          const triggerRect = triggerRef.current.getBoundingClientRect();

          dropdown.addEventListener(
            'click',
            event => event.stopPropagation(),
            false
          );

          overlay.addEventListener(
            'mousedown',
            event => event.stopPropagation(),
            false
          );

          dropdown.style.animation = 'none';
          dropdown.style.opacity = 0;
          dropdown.style.transform = 'translate3d(0, 0, 0)';

          // Force reflow before changing to visible state
          requestAnimationFrame(() => {
            dropdown.style.animation = 'none';
            dropdown.style.opacity = '1';
            dropdown.style.transform = `translate3d(${
              triggerRect.left - dropdownWrapperRect.left + triggerOffset
            }px,${
              triggerRef.current.offsetTop +
              triggerOffset / 2 -
              dropdownHeight / 2
            }px,0)`;
          });
        }
      }, 50);
    },
    [details, isSmall]
  );

  return (
    <div className={classNames(classes.root, className)}>
      <div
        ref={triggerRef}
        id="my-custom-trigger"
        onClick={handleCalendarButtonClick}
      >
        <ActionButton
          rootClass={classNames({ [classes.triggerButtonSmall]: isSmall })}
          iconButtonClass={classNames({ [classes.triggerIconSmall]: isSmall })}
          type={ACTION_BUTTON_TYPES.CALENDAR}
          tooltipText={translations.addToCalendar}
        />
      </div>
    </div>
  );
};

OneOnOneCalendar.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.object.isRequired,
  record: PropTypes.object.isRequired,
  isSmall: PropTypes.bool,
};

export default OneOnOneCalendar;
